var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "inherit",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 15.3c-19.1 0-34.7 15.5-34.7 34.7 0 19.1 15.5 34.7 34.7 34.7S84.7 69.1 84.7 50 69.1 15.3 50 15.3m14.6 47.8c0 .8-.7 1.5-1.5 1.5H36.9c-.8 0-1.5-.7-1.5-1.5V36.9c0-.8.7-1.5 1.5-1.5h26.3c.8 0 1.5.7 1.5 1.5v26.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.48238e8250f0e8ddb35ab1e550a16953.svg";
export { ForwardRef as ReactComponent };